import gql from 'graphql-tag';

export default gql`
  mutation deleteSection($id: UUID!) {
    deleteSection(_id: $id)
  }
`;
